import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";

// const emailRegEx: string =
//   "^([A-Za-z0-9]+([._-]{0,1}[A-Za-z0-9]+)*)[@]{1}[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)+.[A-Za-z]{2,6}$";
// const emailRegEx: string =
//   "^([A-Za-z0-9]+([._-]{0,1}[A-Za-z0-9]+)*)[@]{1}[a-zA-Z0-9-]{0,}(.[a-zA-Z0-9-]+)+.[A-Za-z]{2,6}$";
//-------
// const emailRegEx = "^([A-Za-z0-9]+([._-]{0,1}[A-Za-z0-9]+)*)@([a-zA-Z0-9-]+\\.)+[A-Za-z]{2,4}$";
// const telephoneRegEx: string = "^[+]{1}[1-9]{1}[0-9]{7,}$";
// const urlRegEx: string = `https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}`;

export class GemValidators {
  static emailRegEx = "^([A-Za-z0-9]+([._-]{0,1}[A-Za-z0-9]+)*)@([a-zA-Z0-9-]+\\.)+[A-Za-z]{2,}$";
  static telephoneRegEx: string = "^[+]{1}[1-9]{1}[0-9]{7,}$";
  static urlRegEx: string = `https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}`;
  //static nameRegEx: string =
  //  "^[a-zA-Zäöüß]+(?: (?:[a-zA-Zäöüß]+)|-(?: ?[a-zA-Zäöüß]+)| ?-[ ]?[a-zA-Zäöüß]+)*$";

  private static nameRegEx = new RegExp(
    "^(?=.{2,70}$)(?:\\p{L}[\\p{L}\\p{M}]*|\\p{L}\\.)(?:[ \\-\\u2019'](?:\\p{L}[\\p{L}\\p{M}]*|\\p{L}\\.))*$",
    "u",
  );

  static termsCheckboxRequiredTrue(control: AbstractControl): any | null {
    return GemValidators.termsCheckboxRequired(true)(control);
  }

  static email(control: AbstractControl): any | null {
    return Validators.pattern(new RegExp(GemValidators.emailRegEx))(control);
  }

  static telephone(control: AbstractControl): any | null {
    return Validators.pattern(GemValidators.telephoneRegEx)(control);
  }

  static customPattern = (pattern: string | RegExp, message: string): ValidatorFn => {
    const delegateFn = Validators.pattern(pattern);
    return (control) => (delegateFn(control) === null ? null : { customPattern: message });
  };

  static nameValidator(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const input = control.value;
      if (typeof input !== "string")
        return message ? { customPattern: message } : { pattern: true };

      const name = input.normalize("NFC").trim();
      if (/[ \-\u2019']{2,}/u.test(name))
        return message ? { customPattern: message } : { pattern: true };

      return GemValidators.nameRegEx.test(name)
        ? null
        : message
        ? { customPattern: message }
        : { pattern: true };
    };
  }

  static url(control: AbstractControl): any | null {
    return Validators.pattern(GemValidators.urlRegEx)(control);
  }

  static termsCheckboxRequired(value: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      control.value === value ? null : { termsCheckboxRequired: control.value };
  }

  // static emailPattern(value: string): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } | null => {
  //     if (control.value) {
  //       return String(control.value).match(value) ? null : { pattern: true };
  //     }
  //     return null;
  //   };
  // }

  static pattern(value: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {
        //   return String(control.value).match(value) ? null : { pattern: true };
      }
      return null;
    };
  }

  static requireAtLeastOneCheckboxeToBeCheckedValidator(
    fields: string[],
    minRequired = 1,
  ): ValidatorFn {
    return function validate(formGroup: FormGroup) {
      let checked = 0;
      for (const field of fields) {
        const f = formGroup.get(field);
        if (f.value === true) {
          checked++;
        }
      }
      if (checked < minRequired) {
        return {
          requireAtLeastOneCheckboxeToBeChecked: {
            fields,
          },
        };
      }
      return null;
    };
  }
}
